import { matchPath, useLocation } from 'react-router-dom';

const EXCLUDED_PATTERNS = [
  '/accounts/cards/new',
  '/accounts/info',
  '/invoices/info',
  '/accounts/cashback',
  '/f24/pay',
  '/f24/upload',
  '/settings/team/user/new',
  '/settings/team/user/:companyUserId',
];

const useIsNavExcluded = () => {
  const { pathname } = useLocation();
  return EXCLUDED_PATTERNS.some((pattern) => matchPath(pattern, pathname) !== null);
};

export default useIsNavExcluded;
